import { useEffect, useMemo, useState } from 'react';
import { ONBOARDING_TEMPLATE_REGISTRY } from './onboarding-template-registry';
import useOnboardingFlow from './useOnboardingFlow';

const useTemplate = (): {
  loadingTemplate: boolean;
  Template: React.FC | null;
} => {
  const { currentStepContent } = useOnboardingFlow();

  const [isLoading, setIsLoading] = useState(true);
  const Template = currentStepContent?.template
    ? ONBOARDING_TEMPLATE_REGISTRY[currentStepContent.template]
    : null;

  useEffect(() => {
    setIsLoading(true);
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 200);

    return () => clearTimeout(timer);
  }, [Template]);

  return useMemo(
    () => ({ loadingTemplate: isLoading, Template }),
    [isLoading, Template],
  );
};

export default useTemplate;
